// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"CustomTooltip_tooltipContainer__2PGX1","tooltipLabel":"CustomTooltip_tooltipLabel__3qW8i","tooltipValue":"CustomTooltip_tooltipValue__jnzrJ"};